import { useState } from "react";
import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";

export function DashboardViewModel(logout) {
  const [seasonStatus, setSeasonStatus] = useState(null);
  const [seasonLoading, setSeasonLoading] = useState(false);
  const [switchSeasonLoading, setSwitchSeasonLoading] = useState(false);

  const getSeasonStatus = async function () {
    setSeasonLoading(true);
    const callResult = await makeGetApiCall("settings/season");

    if (callResult.success) {
      setSeasonStatus(callResult.data);
    } else if (callResult.errorStatus === 401) {
      logout();
    }

    setSeasonLoading(false);
  };

  const switchSeasonStatus = async function () {
    if (seasonStatus !== 0 && seasonStatus !== 1) {
      return;
    }

    setSwitchSeasonLoading(true);
    const nextStatus = seasonStatus === 0 ? 1 : 0;
    const callResult = await makePostApiCall("settings/season", {
      status: nextStatus,
    });

    if (callResult.success) {
      setSeasonStatus(callResult.data);
    } else if (callResult.errorStatus === 401) {
      logout();
    }

    setSwitchSeasonLoading(false);
  };

  return {
    getSeasonStatus,
    switchSeasonStatus,
    seasonStatus,
    seasonLoading,
    switchSeasonLoading,
  };
}
